import React from "react";
import "./enem.css";
import Competences from "../../components/competences/competences";
import ListAccordion from "../../components/listAccordion/listAccordion";
import { Row, Col, Container, Button } from "reactstrap";
import EnemLogo from "../../assets/images/enem-logo.png";

const Enem = (props) => {
  const listEnem = [
    {
      id: 1,
      title: "Prepare sua Redação para o Enem",
      subtitle: "Saiba como fazer sua redação no Enem.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce sed ante quis velit dignissim lacinia. Mauris venenatis est lectus, sed imperdiet elit lobortis nec. Phasellus at viverra tellus. Aliquam non eros porttitor, fringilla lacus et, fringilla ante. Aenean id iaculis sapien, vel imperdiet mauris. In vestibulum, erat non faucibus malesuada, nibh ligula gravida elit.",
      baseUrl: "http://basenacionalcomum.mec.gov.br/",
    },
    {
      id: 2,
      title: "Temas das últimas redações do Enem",
      subtitle: "Saiba como quais foram os temas das últimas Redações do Enem.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce sed ante quis velit dignissim lacinia. Mauris venenatis est lectus, sed imperdiet elit lobortis nec. Phasellus at viverra tellus. Aliquam non eros porttitor, fringilla lacus et, fringilla ante. Aenean id iaculis sapien, vel imperdiet mauris. In vestibulum, erat non faucibus malesuada, nibh ligula gravida elit.",
      baseUrl: "http://basenacionalcomum.mec.gov.br/",
    },
    {
      id: 3,
      title: "Temas da atualidade para o Enem",
      subtitle:
        "Saiba os possíveis principais temas propensos a serem abordados no Enem para as próximas provas.",
      description:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce sed ante quis velit dignissim lacinia. Mauris venenatis est lectus, sed imperdiet elit lobortis nec. Phasellus at viverra tellus. Aliquam non eros porttitor, fringilla lacus et, fringilla ante. Aenean id iaculis sapien, vel imperdiet mauris. In vestibulum, erat non faucibus malesuada, nibh ligula gravida elit.",
      baseUrl: "http://basenacionalcomum.mec.gov.br/",
    },
  ];

  const listAccordion = listEnem.map((item) => (
    <ListAccordion item={item} key={item.id} />
  ));

  return (
    <div>
      <Row className="bg-dark" id="enem">
        <Col>
          <Container className="container-enem bg-light w-65">
            <Row>
              <Col className="text-center mt-5">
                <img src={EnemLogo} alt="Logo Oficial do Enem" className="img-fluid" />
              </Col>
            </Row> 
            <Row>
              <Col className="mb-5 mt-5">
                {listAccordion}
              </Col>
            </Row>
            <Row className="mb-5">
              <Col xs="12" xl="12">
                <Button
                  className="font14 borderRadius10 p-2 mt-2 mb-4"
                  color="primary"
                  block
                  href="http://basenacionalcomum.mec.gov.br/abase/#estrutura"
                  target="_blank"
                >
                  VEJA A DESCRIÇÃO DO BNCC PARA O ENSINO MÉDIO
                </Button>
              </Col>
              <Col xs="12" xl="12">
                <Button
                  className="font14 borderRadius10 p-2 mb-5"
                  color="warning"
                  size="block"
                  href="http://basenacionalcomum.mec.gov.br/abase/#medio"
                  target="_blank"
                >
                  ENTENDA A ESTRUTURA DA BNCC NA EDUCAÇÃO CONTINUADA PARA O ENEM
                </Button>
              </Col>
            </Row>
          </Container>
        </Col>
      </Row>
      <Competences></Competences>
    </div>
  );
};

export default Enem;
